import * as React from 'react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { translation as _t } from '../util/translations';

var highlightToggleTexts = [_t('highlightAllTags'), _t('disableHighlightingOfTags')]

export interface FooterProps {
    tagsHighlighted: boolean;
    onToggleTagHighlighting: Function;
    onTransformTags: Function;
}

export class Footer extends React.Component<FooterProps, any> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            tagsHighlighted: false,
            toggleHighlightText: _t('highlightAllTags')
        };
    }

    componentDidMount() {
        this.setState({
            tagsHighlighted: false,
            toggleHighlightText: _t('highlightAllTags'),
        });
    }

    onTransformTags = async () => {
        await this.props.onTransformTags();
    }

    onToggleTagHighlighting = async () => {
        await this.props.onToggleTagHighlighting();
    }

    render() {
        let tagsHighlightIconStyle = {};
        let tagsHighlightTitleText = '';

        if (this.props.tagsHighlighted) {
            tagsHighlightIconStyle = {fontWeight: 'normal'};
            tagsHighlightTitleText = highlightToggleTexts[1]
        } else {
            tagsHighlightIconStyle = {fontWeight: 'normal', color: '#a6a6a6'};
            tagsHighlightTitleText = highlightToggleTexts[0]
        }
        return (
            <section className='ms-footer ms-bgColor-neutralLighter ms-u-fadeIn500'>
                <h3 className="footer-logo">lex<b>search</b></h3>
                <CommandBar
                    style={{paddingRight: 0}}
                    isSearchBoxVisible={ false }
                    searchPlaceholderText={_t('search')}
                    elipisisAriaLabel='More options'
                    overflowItems={[]}
                    items={[]}
                    farItems={ [
                        {
                            key: 'transform_tags',
                            title: _t('transformTags'),
                            onClick: this.onTransformTags,
                            iconProps: {
                                iconName: 'Tag'
                            }
                        }, {
                            key: 'tag_highlight',
                            title: tagsHighlightTitleText,
                            onClick: this.onToggleTagHighlighting,
                            iconProps: {
                                iconName: 'Highlight',
                                style: tagsHighlightIconStyle
                            }
                        }, /*{
                            key: 'settings',
                            canCheck: true,
                            isChecked: true,
                            title: _t('settings'),
                            style: {marginRight: '0px'},
                            iconProps: {
                                iconName: 'Settings'
                            }
                        }*/
                    ] }
                />
            </section>
        );
    };
};



// WEBPACK FOOTER //
// ./components/footer.tsx